import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Box,
  Grid2,
  InputLabel,
  TextField,
  Typography,
  CircularProgress
} from "@mui/material";
import AuthWrapper from "Components/Auth/AuthWrapper";
import LanguageSelection from "Components/Common/LanguageSelection";
import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "Components/Common/Loader";
import PhoneNumberInput from "Components/Common/PhoneNumberInput";
import OTPInput from "Components/Common/OTPInput";
import Timer from "Components/Common/Timer";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactComponent as SMSIcon } from "Assets/Icons/Auth/Msg.svg";
import { ReactComponent as WhatsappIcon } from "Assets/Icons/Auth/Whatsapp.svg";
import { ReactComponent as GoogleIcon } from "Assets/Icons/Auth//GoogleIcon.svg";
import { ReactComponent as FacebookIcon } from "Assets/Icons/Auth//FacebookIcon.svg";
import { ReactComponent as LinkedinIcon } from "Assets/Icons/Auth//LinkedinIcon.svg";
import { ReactComponent as GithubIcon } from "Assets/Icons/Auth//GithubIcon.svg";
import { useFormik } from "formik";
import * as yup from "yup";
import { logIn, googleSignIn, githubSignIn } from "Services/firebase";
import axios from "Services/api";
import { getLanguages } from "Slices/thunks";
import { generateDeviceId } from "Services/service";
import { toast } from 'react-toastify';
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import Cookies from "js-cookie";
import { getOTP } from "Slices/auth/thunk";
import { linkedIn, api } from "config";
import {
  GithubAuthProvider,
  linkWithPopup
} from "firebase/auth";
import { DirectionContext } from "App";


const styles = (theme) => ({
  padding: "30px",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  "& .language": {
    display: "flex",
    justifyContent: "end",
  },
  "& .loginForm": {
    border: `1px solid ${theme.palette.border.blue}`,
    padding: "24px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    maxWidth: "420px",
    margin: "auto",
  },
  "& .otpInput": {
    direction: `${theme.direction} !important`,
  },
  "& .cursorPointer": {
    cursor: "pointer"
  },
  "& .icon": {
    fill: "red"
  },
  "& .btn2": {
    "&:disabled": {
    opacity: 0.7,
    color: theme.palette.white.main,
    background: theme.palette.primary.main,
    cursor: "not-allowed",
    },
  },
  "& .MuiCircularProgress-root": {
    color: `${theme.palette.white.main} !important `,
  }
});


const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState('');
  const [tab, setTab] = useState(2);
  const [seconds, setSeconds] = useState(0);
  const [isEmail, setIsEmail] = useState(true);
  const [onWhatsapp, setOnWhatsapp] = useState(false);
  const [isApiCalling, setIsApiCalling] = useState(false);
  const [minMobileLength, setMinMobileLength] = useState(8);
  
  const linkedInRef = useRef(0);
  const { direction } = useContext(DirectionContext);

  const hostname = window.location.hostname;
  const rootDomain = `.${hostname.split('.').slice(-2).join('.')}`;

  const { Info, Common, Location, isLoading, Translation } = useSelector((state) => ({
    Info: state.Auth.info || {},
    Common: state.Common.common || {},
    Location: state.Common.location || {},
    isLoading: state.Translation.loading,
    Translation: state.Translation.translation?.Login || {},
  }));

  const loginSchema = useMemo(() => {
    return yup.object({
      Email: yup
        .string()
        .required(Translation?.EmailRequired || "Email is required field.")
        .email(Translation?.ValidEmail || "Email should be valid email."),
      DialCode: yup
        .string()
        .required(Translation?.DialcodeRequired || "Dial code is required field."),
      Mobile: yup
        .string()
        .required(Translation?.PhoneNumberRequired || "Phone number is required field.")
        .min(minMobileLength, Translation?.ValidPhoneNumber?.replace('XXX', minMobileLength) || `Phone number should be at least ${minMobileLength} digits.`)
    });
  }, [Translation, minMobileLength]);

  const {
    dirty,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    errors,
    resetForm,
    touched,
    setFieldTouched,
    validateForm
  } = useFormik({
    initialValues: {
      Email: "", 
      DialCode : "",
      Mobile: ""
    },
    enableReinitialize: true,
    onSubmit: async (data) => {
      try {
        const response = await logIn(data.email, data.password);
        // const provider = new GoogleAuthProvider();
        // await linkWithPopup(auth.currentUser, provider);
        handleSessionLogin(response._tokenResponse.idToken)
      } catch (error) {
        console.log('error: ', error);
      }
    },
    validationSchema: loginSchema,
  });

  let socialMedias = [
    {
      label: "Google",
      icon: GoogleIcon,
    },
    // {
    //   label: "Facebook",
    //   icon: FacebookIcon,
    // },
    // {
    //   label: "LinkedIn",
    //   icon: LinkedinIcon,
    // },
    // {
    //   label: "Github",
    //   icon: GithubIcon,
    // },
  ];

  const handleResendOTP = () => {
    if (isEmail) {
      handleSendOTP()
    } else {
      setTab(4)
    }
  } 

  const handleSendOTP = async () => {
    try {
      setIsApiCalling(true);
      await dispatch(getOTP({ IsEmail: isEmail, Email: values.Email, DialCode: values.DialCode, Mobile: values.Mobile, OnWhatsappp: onWhatsapp })).unwrap();
      setIsApiCalling(false);
      setSeconds(30);
      setTab(3);
    } catch (error) {
      console.log("error:", error);
      setIsApiCalling(false);
      if (error.status === 404) {
        toast.error(Translation?.UserDoesNotExist);
      } else {
        toast.error(Translation?.SomethingWentWrong);
      }
    }
  };

  const handleLogin = async () => {
    try {
      // const isValid = await validateForm();
      // console.log('isValid: ', isValid);
      setIsApiCalling(true);
      const response = await logIn(Info.Email, otp);
      await handleSessionLogin(response._tokenResponse.idToken)

    } catch (error) {
      console.log('error: ', error);
      setIsApiCalling(false);
      toast.error(Translation?.OTPMismatch)
    }
  }

  const handleSessionLogin = async (token) => {
    setIsApiCalling(true);


    const deviceId = generateDeviceId();
    Cookies.set("deviceId", deviceId, { 
      expires: 30,
      path: "/",
      secure: true,
      sameSite: "None",
      domain: rootDomain
    });
    Cookies.set("authorization", token, {
      path: "/",
      secure: true,
      sameSite: "None",
      domain: rootDomain
    });

    const data = {
      Maker: navigator.platform,
      Model: navigator.userAgent.split(" ")[0],
      DeviceID: deviceId,
      Platform: "Web",
      AppVersion: "0.0.1",
    };

    try {
      const response = await axios.post('/SaveLoginSession', data, {
        headers: {
          authorization: token
        },
      });
      const tokenObj = response.data;
      Cookies.set("customToken", tokenObj?.refreshToken, {
        expires: 30,
        path: "/",
        secure: true,
        sameSite: "None",
        domain: rootDomain
      });
      setIsApiCalling(false);
      navigate('/');
    } catch (error) {
      console.log('error: ', error);
      setIsApiCalling(false);
      Object.keys(Cookies.get()).forEach((cookieName) => {
        Cookies.remove(cookieName);
      });
      // localStorage.removeItem("CourseID")
      signOut(auth);
      if (error.status=== 404) {
        toast.error(Translation?.UserDoesNotExist);
      } else {
        toast.error(Translation?.SomethingWentWrong);
      }
    }
  }

  const handleSocialLogin = async (socialType) => {
    let response = {};
    try {
      if (socialType === 'Google') {
        response = await googleSignIn();

      } else if (socialType === 'LinkedIn') {
        handleLinkedInLogin();

      } else if (socialType === 'Github') {
        response = await githubSignIn();

      }

      if (socialType !== 'LinkedIn') {
        handleSessionLogin(response._tokenResponse.idToken)
      }

    } catch (error) {
      if (error.code === "auth/account-exists-with-different-credential") {
        toast.error(Translation?.AccountExistsWithDifferentCredential)
      }
    }
  }

  const handleLinkedInLogin = () => {
    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${linkedIn.CLIENT_ID}&redirect_uri=${window.location.origin}/login&scope=openid,profile,email`;

    window.location.href = linkedInAuthUrl;
  };


  const handleLinkedInResponse = async (code) => {
    try {
      setIsApiCalling(true);
      const deviceId = generateDeviceId();
      Cookies.set("deviceId", deviceId, { 
        expires: 30,
        path: "/",
        secure: true,
        sameSite: "None",
        domain: rootDomain
      });

      const response = await fetch(`${api.API_URL}/LinkedInLogin`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "environment": api.ENVIRONMENT, "langid": localStorage.getItem("langId") || 1 },
        body: JSON.stringify({ code,
          Maker: navigator.platform,
          Model: navigator.userAgent.split(" ")[0],
          DeviceID: deviceId,
          Platform: "Web",
          AppVersion: "0.0.1",
        }),
      })
      
      if (response.status === 404) {
        navigate('/login');
        setTimeout(() => {
          toast.error(Translation?.UserDoesNotExist || "User does not exist");
        }, 1500);
        throw new Error(Translation?.UserDoesNotExist)

      } else if (!response.ok) {
        navigate('/login');
        setTimeout(() => {
          toast.error(Translation?.SomethingWentWrong || "Something went wrong");
        }, 1500);
        throw new Error(Translation?.SomethingWentWrong)
        // throw new Error("Failed to authenticate with LinkedIn");
      }
      const res = await response.json();

      const tokenObj = res.data;
      Cookies.set("authorization", tokenObj?.authToken, {
        path: "/",
        secure: true,
        sameSite: "None",
        domain: rootDomain
      });
      Cookies.set("customToken", tokenObj?.refreshToken, {
        expires: 30,
        path: "/",
        secure: true,
        sameSite: "None",
        domain: rootDomain
      });
      setIsApiCalling(false);
      navigate('/');

    } catch (error) {
      console.error("Error: ", error);
      setIsApiCalling(false);
    }
  };

  const getCountryByIP = async () => {
    try {
      // const res = await fetch("https://ipapi.co/json");
      // const data = await res.json();
      // const country = Common?.Country.find((item) => item.CountryCode === data.country_code);
      const country = Common?.Country.find((item) => item.CountryCode === Location.country_code)
      setFieldValue("DialCode", country?.DialCode)
      setMinMobileLength(country?.NumbersLimit)
    } catch (err) {
      console.error("Failed to detect country by IP", err);
      return null;
    }
  }; 

  useEffect(() => {
    if (Array.isArray(Common?.Country) && Location?.country_code) {
      getCountryByIP();
    }

  }, [Location, Common?.Country])

  useEffect(() => {
    dispatch(getLanguages());
   

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    if (code && linkedInRef.current === 0) {
      linkedInRef.current = linkedInRef.current + 1;
      handleLinkedInResponse(code);
    } 
  }, [])

  return (
    isLoading ? <Loader /> :
    <AuthWrapper>
      <Grid2 sx={(theme) => styles(theme)}>
        {/* <Grid2 className="language">
          <LanguageSelection />
        </Grid2> */}

        <form className="loginForm" onSubmit={handleSubmit}>
          { tab === 1 && <>
            <Typography
              marginBottom={"10px"}
              color="primary"
              variant="title"
              fontWeight={500}
            >
              {Translation?.Login}
            </Typography>
            <Typography marginBottom={"30px"} color="secondary.light">
              {Translation?.WelcomeDetailsMessage}
            </Typography>
            <FormControl fullWidth>
              <FormLabel color="secondary" required label>
                {Translation?.EmailId}
              </FormLabel>
              <TextField
                error={touched.email && errors.email}
                helperText={touched.email && errors.email && errors.email}
                onChange={handleChange}
                onBlur={handleBlur}
                type="email"
                name="email"
                size="small"
                placeholder="Enter Your Email"
              />
            </FormControl>
            <FormControl sx={{ marginTop: "10px" }} fullWidth>
              <FormLabel color="secondary" required label>
                {Translation?.Password}
              </FormLabel>
              <TextField
                error={touched.password && errors.password}
                helperText={
                  touched.password && errors.password && errors.password
                }
                type="password"
                onChange={handleChange}
                onBlur={handleBlur}
                name="password"
                size="small"
                placeholder="Password"
              />
            </FormControl>
            <Grid2
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              width={"100%"}
              marginTop={"10px"}
              marginBottom={"20px"}
            >
              <FormControlLabel
                control={<Checkbox size="small" defaultChecked />}
                label={
                  <Typography color="secondary.light">{Translation?.RememberMe}</Typography>
                }
              />
              <Link to="/forgot-password" underline="none">
                {Translation?.ForgotPassword}
              </Link>
            </Grid2>
            <Button className="btn2" type="submit" variant="contained" fullWidth size="large">
              {isApiCalling ? <CircularProgress size={24} sx={(theme) => ({ background: theme.palette.white.main})} /> : Translation?.Login}
              {/* {Translation?.Login} */}
            </Button>

            <Button className="btn2" variant="contained" fullWidth size="large" sx={{mt: 2}} onClick={() => setTab(2)}>
              {isApiCalling ? <CircularProgress size={24} /> : Translation?.LoginWithPhone}
              {/* {Translation?.LoginWithPhone} */}
            </Button>
          </> }

          { tab === 2 && <>
           

            <Grid2 width={"100%"}>
              <Grid2 display="flex" gap="8px"  marginBottom="10px">
                <Button variant={isEmail ? "contained" : "outlined"} size="small" onClick={() => setIsEmail(true)}>{Translation?.Email}</Button>
                <Button  variant={!isEmail ? "contained" : "outlined"} size="small" onClick={() => setIsEmail(false)}>{Translation?.Phone}</Button>
              </Grid2>
            </Grid2>

            { isEmail ?
              <FormControl fullWidth>
                <FormLabel color="secondary" required label>
                  {Translation?.Email}
                </FormLabel>
                <TextField
                  error={touched.Email && errors.Email}
                  helperText={touched.Email && errors.Email && errors.Email}
                  value={values.Email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type="email"
                  name="Email"
                  size="small"
                  placeholder={Translation?.EnterYourEmail}
                />
              </FormControl> :
              <PhoneNumberInput
                label={Translation?.Phone}
                value={values.Mobile}
                dialCodeValue={values.DialCode}
                handleBlur={handleBlur}
                handleChange={handleChange}
                min={minMobileLength}
                onBlur={() => setFieldTouched("DialCode", true)}
                onChange={(value) => {
                  setMinMobileLength(value?.NumbersLimit)
                  setFieldValue("DialCode", value?.DialCode)
                }}
                error={touched.Mobile && errors.Mobile && errors.Mobile}
              />
            }

            <Button className="btn2" variant="contained" fullWidth size="large" sx={{mt: 2}} onClick={handleSendOTP} disabled={isApiCalling || isEmail ? !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.Email)) : values.Mobile?.length != minMobileLength}>
              {isApiCalling ? <CircularProgress size={24} /> : Translation?.SendOTP}
            </Button>

          </> }

          { tab === 3 && <>
            <Grid2 width={"100%"}>
              <Grid2 display="flex">
                <Typography
                  color="secondary.light"
                  variant="body2"
                  fontWeight={500}
                  className="cursorPointer"
                  onClick={() => {
                    setTab(2)
                    setOtp('');
                  }}
                >
                { direction === "rtl" ? <ArrowForwardIcon fontSize="small" /> : <ArrowBackIcon fontSize="small" /> }
                </Typography>

              </Grid2>
            </Grid2>

            <Typography
              marginBottom={"10px"}
              color="primary"
              variant="title"
              fontWeight={500}
            >
              {Translation?.OTPVerification}
            </Typography>
            <Typography marginBottom={"20px"} color="secondary.light">
              {`${Translation?.VerificationMsg} ${isEmail ? values.Email : values.Mobile}`}
            </Typography>

            <FormControl fullWidth>
              <FormLabel color="secondary" required label>
                {Translation?.EnterOTP}
              </FormLabel>
              <Box className="otpInput">
                <OTPInput separator={<span>-</span>} value={otp} onChange={setOtp} length={6} />
              </Box>
            </FormControl>

            <Grid2
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              width={"100%"}
              marginTop={"10px"}
              marginBottom={"10px"}
            >
              { seconds ? 
                <Timer seconds={seconds} setSeconds={setSeconds}/>  :
                <Typography className="cursorPointer" color="secondary.light" onClick={handleResendOTP} disabled={isApiCalling}>{Translation?.ResendOTP}</Typography>
              }
            </Grid2>

            <Button className="btn2" variant="contained" fullWidth size="large" onClick={handleLogin} disabled={isApiCalling || otp.length !== 6}>
               {isApiCalling ? <CircularProgress size={24} color="inherit" /> : Translation?.Login}
              {/* {Translation?.Login} */}
            </Button>
          </> }

          { tab === 4 && <>
            <Grid2 width={"100%"}>
              <Grid2 display="flex">
                <Typography
                  color="secondary.light"
                  variant="body2"
                  fontWeight={500}
                  className="cursorPointer"
                  onClick={() => {
                    setTab(3);
                    setOtp('');
                  }}
                >
                { direction === "rtl" ? <ArrowForwardIcon fontSize="small" /> : <ArrowBackIcon fontSize="small" /> }
                </Typography>

              </Grid2>
            </Grid2>

            <Typography
              marginBottom={"10px"}
              color="primary"
              variant="title"
              fontWeight={500}
            >
              {Translation?.OTPVerification}
            </Typography>
            <Typography marginBottom={"20px"} color="secondary.light">
              {`${Translation?.VerificationMsg} ${isEmail ? values.Email : values.Mobile}`}
            </Typography>

            <Grid2 display="flex" gap="20px"  marginBottom="10px">
              <Button 
                size="small" 
                variant={!onWhatsapp ? "contained" : "outlined"} 
                // color={!onWhatsapp ? "primary" : "secondary"}
                // startIcon={<SMSIcon color={!onWhatsapp ? "white" : "secondary"} /> } 
                startIcon={
                  <PrimaryIcon
                    color={!onWhatsapp ? "white" : "secondary"}
                    icon={SMSIcon}
                    height="18px"
                    width="18px"
                  />
                }
                onClick={() => setOnWhatsapp(false)}>{Translation?.SMSMe}</Button>
              <Button  
                size="small"
                variant={onWhatsapp ? "contained" : "outlined"} 
                // color={onWhatsapp ? "primary" : "secondary"}
                //  startIcon={<WhatsappIcon color={onWhatsapp ? "white" : "secondary"} /> } 
                startIcon={
                  <PrimaryIcon
                    color={onWhatsapp ? "white" : "secondary"}
                    icon={WhatsappIcon}
                    height="18px"
                    width="18px"
                  />
                }
                onClick={() => setOnWhatsapp(true)}>
              {Translation?.WhatsappMe}
              </Button>
            </Grid2>

            <Button className="btn2" variant="contained" fullWidth size="large" sx={{mt: 2}} onClick={handleSendOTP} disabled={isApiCalling}>
              {isApiCalling ? <CircularProgress size={24} /> : Translation?.ResendOTP}
              {/* {Translation?.ResendOTP} */}
            </Button>
          </>
 
          }

          { tab <= 2 && <>
            <Grid2 width={"100%"} margin={"20px 0px"}>
              <Divider grey>{Translation?.OR}</Divider>
            </Grid2>
            <Grid2 width={"100%"}>
              <Typography color="secondary">{Translation?.LoginWithOtherAccounts}</Typography>
              <Grid2
                sx={(theme) => ({
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  marginTop: "15px",
                  "&>button": {
                    minWidth: "0px",
                    padding: "5px",
                    borderColor: theme.palette.border.blue,
                  },
                })}
              >
                {/* {socialMedias?.map((item, i) => {
                  return (
                    <Button variant="outlined" onClick={() => handleSocialLogin(item.label)} disabled={isApiCalling} key={i}>
                      {" "}
                      <item.icon />{" "}
                    </Button>
                  );
                })} */}

                {socialMedias?.map((item, i) => {
                  return (
                    <Button color="secondary" fontSize="18px" variant="outlined" onClick={() => handleSocialLogin(item.label)} disabled={isApiCalling} key={i}>
                      {" "}
                      <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} gap="20px">
                        <item.icon />{" "}
                        <Typography
                          variant="title"
                          fontWeight={600}
                        >
                          {Translation?.LoginWithGoogle}
                        </Typography>
                      </Box>
                    </Button>
                  );
                })}
              </Grid2>
            </Grid2>
          </> }

        </form>
      </Grid2>
    </AuthWrapper>
  );
};

export default Login;
